import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const TtsLanguageDropdownWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 46px;

  .language-dropdown {
    height: 100%;
    input {
      color: ${COLORS.secondaryDark};
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
    }
  }
`
